import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyService, CurrencyCode } from '../../services/core/currency/currency.service';

@Pipe({ name: 'money' })
export class MoneyPipe implements PipeTransform {
  constructor(private currency: CurrencyService) {}

  transform(amount: unknown, sourceCurrency?: CurrencyCode): string {
    const effectiveCurrency = sourceCurrency || this.currency.getBaseCurrency();
    // return this.currency.formatInBase(amount, effectiveCurrency);
    return '';
  }
}
